import { getCurrency as intlGetCurrency } from "intl-data";
import type { Currency } from "intl-data";

export interface CurrencyHackOptions extends Partial<Currency> {
  currency: string;
  symbolRegexp: RegExp;
}
type CurrencyHackOptionsMap = Record<string, Record<string, CurrencyHackOptions>>;

// Do not set decimalPlaces here unless reducing from 2dp
// as "hackData" settings will override currency defaults which includes the
// enforced 2dp limit due to backend restrictions.
export const CurrencyHackData: CurrencyHackOptionsMap = {
  default: {
    MBTC: {
      currency: "BTC",
      symbolRegexp: /BTC/g,
      symbol: "mBTC",
      //decimalPlaces: 3,
    },
    USDT: {
      currency: "BTC",
      symbolRegexp: /BTC/g,
      symbol: "USDT",
      //decimalPlaces: 3,
    },
  },

  // Asian Logic
  asianlogic: {
    IDR: {
      currency: "IDR",
      symbolRegexp: /IDR/g,
      symbol: "Rp",
    },
    KHR: {
      currency: "KHR",
      symbolRegexp: /KHR/g,
      symbol: "៛",
    },
    LAK: {
      currency: "LAK",
      symbolRegexp: /LAK/g,
      symbol: "₭",
    },
    MMK: {
      currency: "MMK",
      symbolRegexp: /MMK/g,
      symbol: "K",
    },
  },
};

function clamp(val: number, min: number, max: number) {
  return Math.max(min, Math.min(val, max));
}

// Backend restrictions mean any stake > 2dp will be rounded off before placement
// to avoid user confusion, ui limits all currencies that are 3dp or more to 2dp.
export function limitDecimalPlaces(intlOptions: Currency | null | undefined) {
  // unknown currencies, restrict to whole numbers
  if (intlOptions == null) return { decimalPlaces: 0 };

  return { ...intlOptions, decimalPlaces: clamp(intlOptions.decimalPlaces ?? 0, 0, 2) };
}

export function getCurrency(code: string, locale: string, provider: string) {
  code = code.toUpperCase();
  let thingy = CurrencyHackData[provider] || CurrencyHackData.default;
  let hack = thingy[code] || CurrencyHackData.default[code];

  if (hack == undefined) return limitDecimalPlaces(intlGetCurrency(code, locale));

  try {
    let r = limitDecimalPlaces(intlGetCurrency(hack.currency, locale));
    return { ...r, ...hack };
  } catch (err) {
    return hack;
  }
}
